import { useState } from "react";
import { loginUser } from "../services/authService";
import { setAuthData } from "../utils/auth";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await loginUser(form);

    console.log("LOGIN RESPONSE:", res.data);

    // Save token correctly
    localStorage.setItem("token", res.data.token);

    // Save user object correctly
    localStorage.setItem(
      "user",
      JSON.stringify({
        userId: res.data.userId,
        name: res.data.name,
        role: res.data.role,
      })
    );

    toast.success("Login Successful 🎉"); 
    const from = location.state?.from || "/";

    // 🔥 Role-based redirect
    if (res.data.role === "Admin") {
      navigate("/admin/dashboard");
    } else {
      navigate(from);
    //navigate("/");
    }

  } catch (error) {
    toast.error("Invalid email or password");
  }
};

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="border-bottom border-2 pb-2">Sign In</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <button type="submit" disabled={loading} className="mt-3">
            {loading ? "Signing In..." : "Login"}
          </button>
        </form>

        <p className="mt-3">
          Don't have an account? <Link to="/register">Sign Up</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;